import React, { PureComponent } from 'react'
import {
  number, bool, string, arrayOf, node, shape,
} from 'prop-types'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import { Locale } from '@active/react-utils/i18n'
import { AddressEditor } from '@active/react-address-editor'

import paymentMethodTypes, { paymentMethodPropType } from '../paymentMethodTypes'

import CreditCardDetail, { defaultIcon as CreditCardIcon } from './CreditCardDetail'
import ECheckDetail, { defaultIcon as ECheckIcon } from './ECheckDetail'
import EUDDDetail, { defaultIcon as EUDDDIcon } from './EUDDDetail'
import ACHDetail, { defaultIcon as ACHIcon } from './ACHDetail'
import './PaymentMethodDetail.scss'

const mappings = {
  [paymentMethodTypes.CREDIT_CARD.getJsonType()]: [CreditCardDetail, ...CreditCardIcon],
  [paymentMethodTypes.ECHECK.getJsonType()]: [ECheckDetail, ...ECheckIcon],
  [paymentMethodTypes.EUDD.getJsonType()]: [EUDDDetail, ...EUDDDIcon],
  [paymentMethodTypes.ACH.getJsonType()]: [ACHDetail, ...ACHIcon],
  asd: [],
}

class PaymentMethodDetail extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    enableIcon: bool,
    content: node,

    remittanceOptions: arrayOf(shape({
      countryCode: string.isRequired,
      currencyCode: string.isRequired,
      remittanceOptionSettingList: arrayOf(shape({
        fieldType: string.isRequired,
        fieldName: string.isRequired,
        required: bool,
        listIndex: number.isRequired,
      })),
    })),
    active: bool,
  }

  static defaultProps = {
    enableIcon: false,
    active: false,
    content: null,

    remittanceOptions: [],
  }

  render() {
    const {
      content, enableIcon, paymentMethod, remittanceOptions, active,
    } = this.props
    const type = paymentMethodTypes.convert(paymentMethod).getJsonType()
    const nameList = paymentMethodTypes.convert(paymentMethod).getCardName()
    if (!type) {
      return null
    }
    const [DetailCom, defaultIcon, iconClass] = mappings[type]
    return (
      <div className="checkout-payments checkout__payment-detail">
        {enableIcon && (
        <div className="checkout__payment-detail--icon">
          <img src={defaultIcon} alt={`${nameList[1]} icon`} className={iconClass} />
        </div>
        )}
        <div className="checkout__payment-detail--alias">
          <span>{paymentMethod.displayName}</span>
        </div>

        <DetailCom fields={paymentMethod} paymentMethod={paymentMethod} remittanceOptions={remittanceOptions}>
          <div className="checkout__payment-detail--address">
            <FormGroup>
              <FormLabel verticalStart><Locale id="passport.lib.components.billingAddress.title" /></FormLabel>
              <div className="ml15">
                <AddressEditor name="address" static />
              </div>
            </FormGroup>
          </div>
          {
            content && (
            <div className="checkout__payment-detail--content" style={{ visibility: active ? 'visible' : 'hidden' }}>
              {content}
            </div>
            )
          }
        </DetailCom>
      </div>
    )
  }
}

export default PaymentMethodDetail
